import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container'
import Card from 'react-bootstrap/Card'

import { base_url, auth_headers } from '../http-auth-data';

const HVACSystem = (props) => {
    const [energy_vector_select, setEnergyVectorSelect] = useState([]);
    const [dataReceived, setDataReceived] = useState(false);

    useEffect(() => {
        fetch(base_url + "/index.php?cmd=vectors", {
            credentials: "include",
            headers: auth_headers
        })
            .then(res => res.json())
            .then(
                (result) => {
                    setEnergyVectorSelect(result.energy_vector_select);
                    setDataReceived(true);
                },
                (error) => {
                    console.log(error)
                }
            )
    }, []);

    if (!dataReceived) {
        return (<Row><Col>Loading...</Col></Row>)
    }
    return (
        <Card className="m-1">
            <Card.Header>
                {`${props.system_type} System`}
            </Card.Header>
            <Card.Body>
                <Container fluid>
                    <Row>
                        <Col xs={4} lg={2}>
                            <Form.Group>
                                <Form.Label>Energy Type</Form.Label>
                                <Form.Control as="select"
                                    id={`${props.system_type}.energy_vector`}
                                    custom
                                    name="energy_vector"
                                    system_type={props.system_type}
                                    disabled={props.disabled}
                                    onChange={(e) => props.changeFunc(e)}
                                    value={props.system_state.energy_vector}
                                >
                                    {energy_vector_select.map(value => {
                                        if (value.typology === "Wood-Pellets") {
                                            return <option key={value.id} value={value.typology} disabled>{value.typology}</option>
                                        } else {
                                            return <option key={value.id} value={value.typology}>{value.typology}</option>

                                        }
                                    })}

                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col xs={4} lg={2}>
                            <Form.Group>
                                <Form.Label>Efficiency</Form.Label>
                                <Form.Control
                                    id={`${props.system_type}.efficiency`}
                                    name="efficiency"
                                    lang="en"
                                    step="any"
                                    type="number"
                                    system_type={props.system_type}
                                    value={props.system_state.efficiency}
                                    disabled={props.disabled}
                                    onChange={(e) => props.changeFunc(e)}
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={4} lg={2}>
                            <Form.Group>
                                <Form.Label>cop</Form.Label>
                                <Form.Control
                                    id={`${props.system_type}.cop`}
                                    name="cop"
                                    lang="en"
                                    step="any"
                                    type="number"
                                    system_type={props.system_type}
                                    value={props.system_state.cop}
                                    disabled={props.disabled}
                                    onChange={(e) => props.changeFunc(e)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={4} lg={2}>
                            <Form.Group>
                                <Form.Label>seer</Form.Label>
                                <Form.Control
                                    id={`${props.system_type}.seer`}
                                    name="seer"
                                    lang="en"
                                    step="any"
                                    type="number"
                                    system_type={props.system_type}
                                    value={props.system_state.seer}
                                    disabled={props.disabled}
                                    onChange={(e) => props.changeFunc(e)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={4} lg={2}>
                            <Form.Group>
                                <Form.Label>Avg. Cost</Form.Label>
                                <Form.Control
                                    id={`${props.system_type}.cost`}
                                    name="cost"
                                    lang="en"
                                    step="any"
                                    type="number"
                                    system_type={props.system_type}
                                    value={props.system_state.cost}
                                    disabled={props.disabled}
                                    onChange={(e) => props.changeFunc(e)}
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={4} lg={2}>
                            <Form.Group>
                                <Form.Label>Max Power</Form.Label>
                                <Form.Control
                                    id={`${props.system_type}.max_power`}
                                    name="max_power"
                                    lang="en"
                                    step="any"
                                    type="number"
                                    system_type={props.system_type}
                                    value={props.system_state.max_power}
                                    disabled={props.disabled}
                                    onChange={(e) => props.changeFunc(e)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={4} lg={2}>
                            <Form.Group>
                                <Form.Label>Technology</Form.Label>
                                <Form.Control
                                    id={`${props.system_type}.technology`}
                                    name="technology"
                                    lang="en"
                                    type="text"
                                    system_type={props.system_type}
                                    value={props.system_state.technology}
                                    disabled={props.disabled}
                                    onChange={(e) => props.changeFunc(e)}
                                />
                            </Form.Group>
                        </Col>
                        </Row>
                </Container>
            </Card.Body>
        </Card>
    );
}

export default HVACSystem